module.exports = __webpack_public_path__ + "img/vegetable-chili-peppers-350x184.5f6efe16.jpg";